import React from 'react';
import { motion } from 'framer-motion';
import { ServerIcon, SmartphoneIcon, StarIcon, ShieldIcon, ZapIcon, SearchIcon } from 'lucide-react';
import { revealVariants } from '../utils/animations';
const features = [{
  icon: ServerIcon,
  text: 'Hosting incluido'
}, {
  icon: SmartphoneIcon,
  text: 'Optimización móvil'
}, {
  icon: StarIcon,
  text: 'Diseño premium'
}, {
  icon: ShieldIcon,
  text: 'Soporte'
}, {
  icon: ZapIcon,
  text: 'Entrega rápida'
}, {
  icon: SearchIcon,
  text: 'SEO básico'
}];
export function TrustStrip() {
  return <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} className="w-full border-y border-white/5 bg-white/[0.02] backdrop-blur-sm py-6 overflow-hidden" data-id="element-371">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-372">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:justify-between md:items-center gap-y-4 gap-x-4" data-id="element-373">
          {features.map((feature, idx) => <div key={idx} className="flex items-center justify-center md:justify-start space-x-2 text-neutral-400" data-id="element-374">
              <feature.icon size={16} className="text-neutral-500 shrink-0" data-id="element-375" />
              <span className="text-sm font-medium tracking-wide text-center md:text-left" data-id="element-376">
                {feature.text}
              </span>
            </div>)}
        </div>
      </div>
    </motion.div>;
}